module.exports = __webpack_public_path__ + "img/orderSiteDistributionRight@1x.ce132649.png";